import { ReactNode } from 'react';
import getAmoutValue from 'ui/structure/AmountValue/AmountValue';
import { ITransactionField } from 'ui/structure/TransactionCard';
import { objectMap } from 'utils/helpers';
import { ghsFormatter, formatTwoDigitDate, amountFormatter } from 'utils/formatters';

// Can be expanded or splitted to modules
export const transactionDataConfig = {
  transactionId: 'Transaction ID:',
  bulkId: 'Bulk ID:',
  scheduleId: 'Schedule ID:',
  transferType: 'Transfer Type:',
  sourceAccount: 'Source Account:',
  destinationAccountName: 'Beneficiary:',
  walletName: 'Wallet Name:',
  phoneNumber: 'Wallet Number:',
  beneficiaryWalletNumber: 'Wallet Number:',
  networkCode: 'Network:',
  transactionNarration: 'Narration:',
  charge: 'Transaction Charge:',
  createDate: 'Transaction Date:',
  totalAmount: 'Total Amount:',
  transactionAmount: 'Amount:',
  workFlowStatus: 'Transaction Status:',
  SourceAccountType: 'Source Account Name:',
  elevyFee: 'E-Levy:',
};

export const transactionValuesMapper = (value: string | number, key: string) => {
  switch (key) {
    case 'amount':
    case 'totalAmount':
    case 'elevyFee':
    case 'charge':
      return amountFormatter('ghs', false)(String(value));
    case 'createDate':
      return formatTwoDigitDate(value);
    case 'transactionAmount':
      return amountFormatter('ghs', false)(String(value));
    case 'transactionCharge':
      return ghsFormatter.format(Number(value));
    default:
      return value;
  }
};

export const getTransactionsArray = (
  data: Record<string, string | number>,
  config: Record<string, string> = transactionDataConfig,
  mapper: (value: string | number, key: string) => ReactNode = transactionValuesMapper,
  sortArray?: string[],
  currency = 'GHS',
): ITransactionField[] => {
  const mappedData = objectMap<ReactNode, string | number>(data, mapper, config);
  const transactionsArray: ITransactionField[] = [];
  const loopWithKeys = sortArray || Object.keys(mappedData);

  loopWithKeys.forEach((key) => {
    const value = mappedData[key];
    if (typeof value === 'undefined') return;
    if (key === 'Transaction Amount:') {
      transactionsArray.push({
        label: key,
        value: getAmoutValue(
          data[
            key
              .toLocaleLowerCase()
              .replaceAll('', '')
              .slice(0, key.length - 1)
          ],
          currency,
        ),
      });
    } else {
      transactionsArray.push({ label: key, value });
    }
  });

  return transactionsArray;
};
